<template>
	<div
		class="child-stars-card-container d-flex shadow overflow-hidden bg-white position-relative h-px-120 p-0 m-0"
		:class="customClass"
	>
		<div class="child-stars-main-icon-container bg-smooth-yellow align-items-center custom-rounded-right">
			<img class="child-stars-main-icon" :src="require('@/assets/icons/icon-stars.svg')" />
		</div>
		<div class="child-stars-content d-flex flex-column justify-content-center align-items-center">
			<span class="start-title">{{ text }}</span>
			<div class=" stars-data d-flex align-items-center">
				<span class="stars-value">{{ value }}</span>
				<b-img :src="require('@/assets/star.png')" class="star-icon icon-star-small"></b-img>
			</div>
		</div>
		<div class="small-circle position-absolute bg-smooth-yellow rounded-circle"></div>
	</div>
</template>

<script>
export default {
	props: {
		text: String,
		value: Number,
		customClass: String,
	},
	data() {
		return {};
	},
};
</script>

<style scoped lang="scss">
* {
    position: relative;
    text-align: center;
}
.h-px-120 {
	min-height: 120px;
	height: 120px;
	max-height: 120px;
}

.child-stars-card-container {
    flex-grow: 1;
	border-radius: 10px 10px 30px 10px;
	min-width: fit-content;
    justify-content: space-between;
    max-width: 420px;
    
	.half-circle {
		width: 100px;
		height: 120px;

		margin-left: -60px;
	}

	.pt-100 {
		padding-top: 100%;
	}

	.bg-smooth-yellow {
		background: #ffefb9 0% 0% no-repeat padding-box;
	}

	.custom-rounded-right {
		border-top-right-radius: 50%;
		border-bottom-right-radius: 50%;
	}

	.small-circle {
		width: 120px;
		height: 120px;
		bottom: -60px;
		right: -60px;
	}

	.child-stars-main-icon-container {
		// padding-left: 37px;
		align-self: center;
		min-height: fit-content;
		height: fit-content;
		padding: 37px;
		z-index: 1;
	}

	.child-stars-content {
        margin: auto;
        z-index: 500;
		.start-title {
			font-weight: 600;
		}
		.stars-value {
			font-size: 34px;
		}
        .stars-data {
            gap: 5px;
        }
	}
}
</style>
